<template>
  <div>
    <section-title
      class="section-title__extended mt-4"
      content="Historial de Addendums"
      icon="fas fa-history text-orange"
      reverse
    />

    <custom-result-not-found v-if="history.length === 0" />

    <time-line class="mt-4">
      <div v-for="(item, index) in history" :key="`item-index-${index}`">
        <time-line-item class="custom-time-line rounded">
          <template #icon>
            <em class="fas fa-retweet radius" />
          </template>
          <template #date>
            <div class="date-container">
              <div class="color-black font-16 font-weight-bold fulldate">
                {{ item.date | date }}
              </div>
              <div class="color-black font-12 font-weight-normal hour">
                {{ item.date | hour }}
              </div>
            </div>
          </template>
          <div class="row py-4 mx-3">
            <div class="col-md-2 col-sm-12 border-right">
              <div class="color-gray-12 font-weight-bold mb-2">
                Addendum 0{{ history.length - index }}
              </div>
              <div class="color-gray-6 font-14 font-weight-normal">
                Estatus:
              </div>
              <div class="d-flex align-items-center">
                <em
                  class="fas fa-circle mr-2"
                  :class="`font-12 color-${getStatusColor(status.id)}`"
                />
                <div class="color-black font-16 font-weight-normal">
                  {{ status.name }}
                </div>
              </div>
            </div>
            <div class="col-md-10">
              <div class="row">
                <div class="col ml-5 ml-md-5 ml-sm-0">
                  <div class="color-gray-6 font-14 font-weight-normal">
                    Razón:
                  </div>
                  <div class="color-black font-16 font-weight-normal">
                    {{ item.reasons }}
                  </div>
                </div>
                <div class="col ml-5 ml-md-5 ml-sm-0">
                  <div class="color-gray-6 font-14 font-weight-normal">
                    Comentario:
                  </div>
                  <div class="color-black font-16 font-weight-normal">
                    {{ item.comment }}
                  </div>
                </div>
                <div class="col ml-5 ml-md-5 ml-sm-0">
                  <div class="color-gray-6 font-14 font-weight-normal">
                    Añadido por:
                  </div>
                  <div class="color-black font-16 font-weight-normal">
                    {{ item.userFullName }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </time-line-item>
      </div>
    </time-line>
  </div>
</template>
<script>
import SectionTitle from 'SectionTitle';
import CustomResultNotFound from 'custom-result-not-found';
import { TimeLine, TimeLineItem } from '@quisit/mipe-timeline';
import { getStatusColor as _getStatusColor } from '@/utils/constants/announcementStatus.js';

export default {
  name: 'AddendumHistory',
  components: {
    SectionTitle,
    CustomResultNotFound,
    TimeLine,
    TimeLineItem,
  },
  props: {
    history: {
      type: Array,
      default: () => [],
    },
    status: {
      type: Object,
      default: () => null,
    },
  },
  methods: {
    getStatusColor(statusId) {
      return _getStatusColor(statusId);
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/shared/scss/config/colors.scss';

.section-title__extended ::v-deep {
  .dot {
    background-color: #fff !important;
  }
}

::v-deep .custom-time-line {
  div:first-child {
    margin-right: 0px !important;
    padding-right: 10px !important;
  }
  .timeline__content--inner {
    padding: unset !important;
  }
  .icon-absolute {
    top: 20px;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
  }
  em.radius {
    background: map-get($colors, 'gray-2');
    color: #fff;
    box-shadow: 0px 3px 6px #00000029;
  }
}
</style>
